/**
 * Runtime game settings that persist within a session.
 * Shared between camera, ticker, and the settings dialog.
 */
export const gameSettings = {
  /**
   * Multiplier for AI animation speed.
   * Higher = faster enemy moves. 1 = slow/comfortable, 5 = very fast.
   * Controls camera pan duration and delay between AI unit actions.
   */
  aiAnimSpeed: 2,
  /** Multiplier for camera scroll speed. 1 = normal (700px/s), 2 = double, etc. */
  scrollSpeed: 1,
};

/* Base timing for AI move animations (milliseconds at aiAnimSpeed = 1). */
export const AI_ANIM_BASE_PAN_MS = 600;
export const AI_ANIM_BASE_DELAY_MS = 500;
